<section>
    <form [formGroup]="filterForm" class="container-filter">
        <mat-form-field>
            <mat-label>Busqueda</mat-label>
            <input formControlName="search" matInput (keyup.enter)="onSearch()">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Finalidad</mat-label>
            <mat-select formControlName="finalidad" (selectionChange)="sendFilters()">
                <mat-option *ngFor="let filter of selectFiltersFinalidad"
                [ngClass]="{'hidden': filter.value === 0}"
                [value]="filter.value">
                {{filter.text}}
                </mat-option>
            </mat-select>    
        </mat-form-field>

        <mat-form-field>
            <mat-label>Acción</mat-label>
            <mat-select formControlName="estadoAccion" (selectionChange)="sendFilters()">
                <mat-option [value]="''">Todas</mat-option>
                <mat-option *ngFor="let filter of selectFiltersAccion"
                [value]="filter.name">
                {{filter.name}}
                </mat-option>
            </mat-select>    
        </mat-form-field>

        <mat-form-field>
            <mat-label>Estado del Trato</mat-label>
            <mat-select formControlName="estado" (selectionChange)="sendFilters()">
                <mat-option *ngFor="let filter of selectFiltersEstadoDeal"
                [ngClass]="{'hidden': filter.value === 0}"
                [value]="filter.value">
                {{filter.text}}
                </mat-option>
            </mat-select>    
        </mat-form-field>

        <mat-form-field>
            <mat-label>Estado Resolutivo</mat-label>
            <mat-select formControlName="estadoActiviti" (selectionChange)="sendFilters()">
                <mat-option *ngFor="let filter of selectFiltersEstadoActiviti"
                [value]="filter.value">
                {{filter.text}}
                </mat-option>
            </mat-select>    
        </mat-form-field>

        <mat-form-field>
            <mat-label>Etiqueta</mat-label>
            <mat-select formControlName="etiqueta" (selectionChange)="sendFilters()">
                <mat-option [value]="''">Todas</mat-option>
                <mat-option *ngFor="let filter of tags"
                [value]="filter">
                {{filter}}
                </mat-option>
            </mat-select>    
        </mat-form-field>

        <mat-form-field>
            <mat-label>Elige rango de días</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate (dateInput)="changeDateInput($event)" formControlName="start" placeholder="Inicio">
                <input matEndDate (dateInput)="changeDateInput($event)" formControlName="end" placeholder="Termino">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel (click)="resetDateRangePicker()">Limpiar</button>
                    <button mat-raised-button (click)="applyDateRangePicker()" color="primary" matDatepickerApply>Aplicar</button>
                  </mat-datepicker-actions>                        
            </mat-date-range-picker>
        </mat-form-field>

    </form>
</section>